module.exports = __webpack_public_path__ + "img/plus.02a44351.svg";